import type { Rivalry } from "@averagejoesff/shared";
import { formatRecord } from "../../lib/format";
import type { ManagerLookup } from "./managers";
import { managerName } from "./managers";

/** "Blake leads 12–4" / "All square at 5–5" — who's ahead in an oriented rivalry. */
export function seriesSummary(rivalry: Rivalry, managers: ManagerLookup): string {
  const [leftId, rightId] = rivalry.managerIds;
  const [leftWins, rightWins] = rivalry.wins;
  if (leftWins === rightWins) return `All square at ${formatRecord(leftWins, rightWins, rivalry.ties)}`;
  return leftWins > rightWins
    ? `${managerName(managers, leftId)} leads ${formatRecord(leftWins, rightWins, rivalry.ties)}`
    : `${managerName(managers, rightId)} leads ${formatRecord(rightWins, leftWins, rivalry.ties)}`;
}

/**
 * The in-page anchor for one weekly game's card, shared by the card, the
 * slate on that page and Home's slate, which links here. Independent of which
 * side is listed first, since the two pages may order a game differently.
 */
export function matchupAnchorId(managerIds: readonly [string, string]): string {
  return `matchup-${[...managerIds].sort().join("-")}`;
}
